import React, { ReactElement, FC } from 'react';
import cn from 'classnames';
import { IIconProps } from '../../Icon/Icon';
require("./Textarea-Icon.css");
var styles = {
  "Root": "Textarea-Icon-module-Root_VwT",
  "leftSide": "Textarea-Icon-module-leftSide_2Z8",
  "rightSide": "Textarea-Icon-module-rightSide_2lI"
};
export const TextareaIcon = ({
  component,
  side,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(styles.Root, styles[`${side}Side`], [component.props.className], className)
}, component);